import { TrafficType } from '@campaign-portal/namespace/common/enums';

import { HEX_RADIX } from '../constants';

const URL_PATTERN = /https?:\/\/[a-zA-Z0-9$\-_.+!*'/&?=:%#]+/g;

const SHORT_LINK_PATTERN = (host?: string): RegExp => {
	const hostPattern = host ?? `(?<host>[^\\]]*)`;

	return new RegExp(`\\[${hostPattern}\\]\\((?<url>https?://[a-z0-9$\\-_.+!*'/&?=:%#]+)\\)`, 'gi');
};

const LINK_DOMAIN_TEMPLATE = (host: string): string => {
	return `https://${host}/xxxxxx`;
};

// eslint-disable-next-line sonarjs/redundant-type-aliases
type UrlId = string;

export class ChannelMessageToHTMLtoSerializer {
	private message = '';
	private readonly urlsMap = new Map<UrlId, string>();

	constructor(message: string) {
		this.message = message;
	}

	get value(): string {
		return this.message;
	}

	addVariableStyling(): this {
		this.message = this.message.replaceAll(/%(.*?)%/g, `<span class="variable">$1</span>`);
		return this;
	}

	addUrlStyling(): this {
		this.message = this.message.replaceAll(URL_PATTERN, `<a target="_blank" href="$&" class="link">$&</a>`);
		return this;
	}

	addLinkDomains(): this {
		const match = [...this.message.matchAll(SHORT_LINK_PATTERN())].at(0);
		if (match) {
			const host = match.groups?.host ?? '';
			this.message = this.message.replace(SHORT_LINK_PATTERN(), LINK_DOMAIN_TEMPLATE(host));
		}
		return this;
	}

	changeFontDecorationTag(viberSymbol: string, htmlTag: string): this {
		const regex = new RegExp(`${viberSymbol}(.*?)${viberSymbol}`, 'g');
		this.message = this.message.replace(regex, `<${htmlTag}>$1</${htmlTag}>`);
		return this;
	}

	replaceUrlsToIds(): this {
		this.message = this.message.replaceAll(URL_PATTERN, (url) => {
			const id = `URL-ID={${Math.random().toString(HEX_RADIX).split('.')[1]}}`;
			this.urlsMap.set(id, url);
			return id;
		});
		return this;
	}

	restoreUrlsFromIds(): this {
		this.urlsMap.forEach((url, id) => {
			this.message = this.message.replace(id, url);
		});
		return this;
	}
}

export function convertToHTMLFormat(channel: TrafficType, message?: string): string {
	const channelTemplateMessage = new ChannelMessageToHTMLtoSerializer(message ?? '')
		.addUrlStyling()
		.addVariableStyling();

	if (channel !== TrafficType.SMS) {
		channelTemplateMessage
			.replaceUrlsToIds()
			.changeFontDecorationTag(String.raw`\*`, 'b')
			.changeFontDecorationTag('_', 'i')
			.changeFontDecorationTag('~', 'strike')
			.restoreUrlsFromIds();
	}
	return channelTemplateMessage.value;
}
